import React from 'react';
import { ProjectInstallationRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';


export type ProjectInstallationTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationTableProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const headers = [
    'Name',
    'Area',
    'Category',
    'Plan ID',
    'Outstanding Decisions',
    'Decision Due Date',
    ''
  ];

  // const rows = useMemo(() => {
  const tempRows = data.map((node, i) => (
    <ProjectInstallationRow.FC
      key={i}
      id={node.id}
      area={node.area}
      type={node.type}
      numberOfActiveDecisions={node.numberOfActiveDecisions}
      estStartDate={node.estimatedStartDate}
      name={node.name}
      planId={node.planId}
      status={node.status}
    />
  ));
  //   return tempRows;
  // }, [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={tempRows}
    />


  );
};
